import { render, staticRenderFns } from "./TheTableRestaurantOrders.vue?vue&type=template&id=4372907d&scoped=true&"
import script from "./TheTableRestaurantOrders.vue?vue&type=script&lang=ts&"
export * from "./TheTableRestaurantOrders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372907d",
  null
  
)

export default component.exports